import { Component, OnInit } from '@angular/core';
import {
	FlashProduct,  
	EditFlashProductModel,  
} from '../../../models/inModels/Flash';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { NotificationContentType } from '../../../models/inModels/MessageModel';
import { Router } from '@angular/router';
import { FlashService } from '../../../services/flash/flash.service';
import { DataTable } from 'primeng/components/datatable/datatable';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-flash-product',
  templateUrl: './flash-product.component.html'
})
export class FlashProductComponent implements OnInit {
  	items: FlashProduct[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	displayDialog: boolean = false;
	selectedFlashProduct: FlashProduct;
  constructor(
    private service: FlashService,
		private router: Router,
		private confirmationService: ConfirmationService,
		public storageService: StorageService,
  ) {
    this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
   }

  ngOnInit() {
	
  }
  changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

  load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
        		this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
  }

  delete(event: FlashProduct) {
		console.log(event);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${event.Name}?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(event.ProductCode).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
  }
  
	edit(item: FlashProduct) {
		this.router.navigate(['flash/products/edit', item.ProductCode]);
	}

	openModal(item: FlashProduct) {
		this.displayDialog = true;
		this.selectedFlashProduct = item;

		console.log(this.selectedFlashProduct)
	}
  
}



// WEBPACK FOOTER //
// ./src/app/components/flash/products/flash-product.component.ts